import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { isOpenAddStepMenu } from '../selectors'

export function useIsOpenAddStepMenu() {
  return useSelector<RootState, boolean>(isOpenAddStepMenu)
}
